/* SPF INFINI cart: the Buy Button's slide-out cart and sticky cart toggle, on the native cart.
 * Markup and CSS live in snippets/spf-cart.liquid (shadow roots); this renders lines from
 * /cart.js, changes quantities with /cart/change.js and sends Checkout to /checkout.
 * window.spfCart = { open, close, refresh }.
 */
(function () {
  var frame = document.querySelector('[data-spf-cart-frame]');
  var toggleFrame = document.querySelector('[data-spf-cart-toggle]');
  if (!frame) return;
  var panel = frame.querySelector('spf-cart-panel').shadowRoot;
  var toggle = toggleFrame && toggleFrame.querySelector('spf-cart-toggle').shadowRoot;
  var list = panel.querySelector('.shopify-buy__cart-items');
  var empty = panel.querySelector('.shopify-buy__cart-empty-text');
  var subtotal = panel.querySelector('.shopify-buy__cart__subtotal__price');
  var checkout = panel.querySelector('.shopify-buy__btn--cart-checkout');
  var moneyFormat = frame.getAttribute('data-money-format');
  var lineTemplate = panel.querySelector('template[data-line]');
  var state = null;

  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function render(cart) {
    state = cart;
    list.textContent = '';
    cart.items.forEach(function (item, i) {
      var li = lineTemplate.content.firstElementChild.cloneNode(true);
      var img = item.image || '';
      li.querySelector('.shopify-buy__cart-item__image').style.backgroundImage = img ? 'url(' + img + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=180&height=180)' : '';
      li.querySelector('.shopify-buy__cart-item__title').textContent = item.product_title;
      var vt = li.querySelector('.shopify-buy__cart-item__variant-title');
      if (item.product_has_only_default_variant) vt.remove(); else vt.textContent = item.variant_title;
      li.querySelector('.shopify-buy__cart-item__price').textContent = money(item.final_line_price);
      var input = li.querySelector('.shopify-buy__cart-item__quantity-input');
      input.value = item.quantity;
      li.querySelector('.shopify-buy__quantity-decrement').addEventListener('click', function () { change(i + 1, item.quantity - 1); });
      li.querySelector('.shopify-buy__quantity-increment').addEventListener('click', function () { change(i + 1, item.quantity + 1); });
      input.addEventListener('change', function () { change(i + 1, Math.max(0, parseInt(input.value, 10) || 0)); });
      list.appendChild(li);
    });
    empty.style.display = cart.item_count ? 'none' : '';
    subtotal.textContent = money(cart.total_price);
    checkout.disabled = !cart.item_count;
    if (toggle) {
      toggle.querySelector('.shopify-buy__cart-toggle__count').textContent = cart.item_count;
      toggleFrame.classList.toggle('is-active', cart.item_count > 0);
    }
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render);
  }

  function change(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    frame.classList.add('is-visible', 'is-active');
    if (toggleFrame) toggleFrame.classList.add('is-hidden-by-cart');
  }

  function close() {
    frame.classList.remove('is-active');
    if (toggleFrame) toggleFrame.classList.remove('is-hidden-by-cart');
    setTimeout(function () { if (!frame.classList.contains('is-active')) frame.classList.remove('is-visible'); }, 260);
    if (frame.hasAttribute('data-close-to')) location.href = frame.getAttribute('data-close-to');
  }

  panel.querySelector('.shopify-buy__btn--close').addEventListener('click', close);
  checkout.addEventListener('click', function () { location.href = '/checkout'; });
  if (toggle) toggle.querySelector('.shopify-buy__cart-toggle').addEventListener('click', open);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && frame.classList.contains('is-active')) close(); });

  window.spfCart = { open: open, close: close, refresh: refresh };
  refresh().then(function () { if (frame.hasAttribute('data-open')) open(); });
})();
